import { Id } from "./id";
import { Identifiable } from "./identifiable";
import { Zone, zone } from "./zone";
import { WorkloadProjectPeriod } from "./workloadProjectPeriod";

type ProjectWorkload = {
  uuid: Id;
  name: string;
  zone: Identifiable<Zone>;
  periods: WorkloadProjectPeriod[];
  projectMember: boolean;
};

const projectWorkload: ProjectWorkload = {
  uuid: "",
  name: "",
  zone: { ...zone, uuid: "" },
  periods: [],
  projectMember: false,
};

export type { ProjectWorkload };

export { projectWorkload };
